import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import React from 'react'
import { StorageLayoutGraphic } from '../StorageLayout'
import {
  LayoutModalAppBar,
  LayoutModalBody,
  LayoutModalInner,
  LayoutModalTitle,
  LayoutModalToolbar,
} from './styled'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const StorageLayoutModal: React.FC<{
  open: boolean
  onClose: () => void
  height: number
}> = ({ open, onClose, height }) => (
  <Dialog
    fullScreen
    open={open}
    onClose={onClose}
    TransitionComponent={Transition}
  >
    <LayoutModalAppBar className="storage-layout-modal__app-bar">
      <LayoutModalToolbar className="storage-layout-modal__toolbar">
        <LayoutModalTitle className="storage-layout-modal__title">
          Storage Layout
        </LayoutModalTitle>
        <IconButton
          className="storage-layout-modal__close-button"
          edge="start"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </LayoutModalToolbar>
    </LayoutModalAppBar>
    <LayoutModalBody
      className="storage-layout-modal__body"
      viewportHeight={height}
    >
      <LayoutModalInner className="storage-layout-modal__inner">
        <StorageLayoutGraphic immersive />
      </LayoutModalInner>
    </LayoutModalBody>
  </Dialog>
)
